import React, { FC, useCallback, useContext, useMemo } from "react";
import { useDeterminedDirection } from "../../selectors/useDeterminedDirection";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";
// import DruidWebchatRefsContext, { DruidWebchatRefsContextType } from "../../contexts/WebChatRefsContext";
// import useStyleToEmotionObject from 'botframework-webchat-component/lib/hooks/internal/useStyleToEmotionObject';


import { hooks } from 'botframework-webchat-component';

import Dropdown from 'react-bootstrap/Dropdown';
import { useBotLanguages, useSelectedLanguage } from "../../selectors/useBotLanguages";
import classNames from "classnames";
import { useMergedOptions } from "../../selectors/useMergedOptions";
import { useWebChatRefsContext } from "../../hooks/useWebChatRefsContext";
import useDruidLocalize from "../../hooks/useDruidLocalize";
import { FaGlobe } from 'react-icons/fa';
import { AppConsts } from "../../logics/druidBusinessLogic";


const {  useDictateState } = hooks;

export const DruidLanguageSelector: FC = () => {
  const [druidWebChatState, druidWebChatDispatch, ,druidStyleToEmotionObject] = useContext<DruidWebchatContextType>(DruidWebchatContext);
  const { headerRef } = useWebChatRefsContext();
  const { 
    styleOptions : { subtle, sendBoxButtonColorOnDisabled, sendBoxButtonColorOnHover, sendBoxButtonColorOnFocus, paddingRegular, accent, sendBoxButtonShadeColor } = {},
    disabled,
    UI: { buttonsTextColor, headerTextColor, rootFontSize, headerButtonColorOnFocus, headerFontSize, restylingsEnabled } = {}
  } = useMergedOptions();

  const { sensitiveDataInputMode } = druidWebChatState;

  const selectedLanguage = useSelectedLanguage();
  const botLanguages = useBotLanguages();
  const druidLocalize = useDruidLocalize();

  const [dictateState] = useDictateState();
  const determinedDir = useDeterminedDirection();
  const dropdownToggle_Transform_scaleValue = useMemo(() => {
    // 11 (13 with padding) is famfamfam icon size. use 14 for calculations, just to be a smaller
    return headerRef ? parseInt(parseFloat(getComputedStyle(headerRef.querySelector('.druid__webchat__header-title')!).height).toFixed()) / 14: (20 /11);
  }, [headerRef])
  // const styleToEmotionObject = useStyleToEmotionObject();

  const orderedBotLanguages = useMemo(() => {
    // https://tc39.es/ecma402/#sec-intl.collator.prototype.compare
    return botLanguages?.sort((a, b) => a.nativeName.localeCompare(b.nativeName, undefined, {sensitivity: 'base'})) || [];
  }, [botLanguages]);

  const ROOT_STYLE = {
    '&.druid__webchat__header__language-menu': {
         display: 'flex',
         animationName: 'fadeIn',
         animationDuration: '1s',
         paddingLeft: 5,
         paddingRight: 5,
         direction: determinedDir,
        ' > .dropdown-toggle': {
          display: 'flex',
          color: headerTextColor,
          backgroundColor: 'transparent',
          border: 0,
          paddingLeft: 5,
          paddingRight: 5,
          transform: `scale(${selectedLanguage?.id !== AppConsts.DefaultLanguageId ? dropdownToggle_Transform_scaleValue : 1})`, 
          '&:hover': {
            boxShadow: 'none',
            color: subtle
          },
          '&:focus' : {
            boxShadow: 'none',
            color: subtle 
          },
          '&:focus-visible': {
            outline: 0,
          },
          '&:focus-visible > span': {
            outline: `1px ${headerButtonColorOnFocus || sendBoxButtonColorOnFocus} solid`,
          },
          '&[disabled]': {
            color: sendBoxButtonColorOnDisabled,
            opacity: '50%'
          },
          '&::after': {
            display: 'none'
          }
        },
        '.dropdown-menu' : {
          textAlign: determinedDir === 'rtl' ? 'right': 'left',
          ...(restylingsEnabled && 
            { padding: '0.5rem',
              marginBottom: 10,
              boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 6px',
              border: 'none',
            }),
          '.dropdown-item': {
            fontSize: rootFontSize,
            alignItems: 'center',
            '& > strong': {
              color: accent
            },
            '&:active': {
              backgroundColor: buttonsTextColor
            },
            ...(restylingsEnabled && 
              {
                height: '3rem',
                display: 'flex',
                alignItems: 'center',
                '&:hover, &:active': {
                  backgroundColor: sendBoxButtonShadeColor
                }
            }),
            '& > span': {
              display: 'inline-block',
              marginLeft: 5
            }
          }
        },
    }
  };

  const rootClassName = druidStyleToEmotionObject(ROOT_STYLE) + '';
  return (
    <Dropdown className={classNames('druid__webchat__header-button', 'druid__webchat__header-fadeIn', 'druid__webchat__header__language-menu',  rootClassName + '')}  role="menu" drop="down">
      {/* variant sets btn btn-primary by default. keep string empty */}
      <Dropdown.Toggle variant="" title={druidLocalize("DRUID_SELECT_LANGUAGE_BUTTON_ALT")} as="div" tabIndex={0} role={'button'}
      disabled={disabled || dictateState !== 0 || sensitiveDataInputMode} aria-disabled={disabled || dictateState !== 0 || sensitiveDataInputMode}>
        {
          selectedLanguage?.id !== AppConsts.DefaultLanguageId ? 
            <span className={selectedLanguage?.icon}></span>
            :
            <>
              <FaGlobe size={headerFontSize!}></FaGlobe>
              {/* <label style={{position: 'absolute', margin: 'auto', color: 'white'}}>A</label> */}
            </>
        }
      </Dropdown.Toggle>
      {/* <Dropdown.Toggle>
      </Dropdown.Toggle> */}

      <Dropdown.Menu renderOnMount={true}>
      {
        botLanguages.filter(bl => bl.id !== AppConsts.DefaultLanguageId).map((lang, idx) => {

          return (<React.Fragment key={`${lang}_${idx}`} >
            <Dropdown.Item role="menuitem" data-lang={lang.name} href={void(0)} onClick={() => { druidWebChatDispatch({type:'SET_SELECTEDLANGUAGE', payload: lang.name})}}>{lang.nativeName}  <span className={classNames(lang?.icon, "druid__webchat__header__language-select-icon")}></span></Dropdown.Item>
            {!restylingsEnabled && (idx + 1 < botLanguages.filter(bl => bl.id !== AppConsts.DefaultLanguageId).length) && <Dropdown.Divider />}
          </React.Fragment>)
        })
      }
    </Dropdown.Menu>
  </Dropdown>
  );
}